module.exports = __webpack_public_path__ + "img/module_form.04d5110d.jpg";